'use strict';

/* globals RELATIVE_PATH */

require([
	RELATIVE_PATH + '/plugins/nodebb-plugin-courses/static/vendor/vue.js',
], function (Vue) {
	Vue.component('course-files', {
		props: ['initData'],
		data: function () {
			return {
				files: this.initData.files,
			};
		},
		template:
		'<ul class="chapters-list files-list">' +
			'<li v-for="(file, index) in files">' +
				'<a :href="file.url" target="_blank">{{file.name}}</a>' +
			'</li>' +
		'</ul>',
	});
});
